import { LinearGradient } from 'expo-linear-gradient';
import { type ColorSchemeName } from 'react-native';
import {
    GRADIENT_COLOR_BOTTOM,
    GRADIENT_COLOR_TOP,
    useThemeColors,
} from 'smoothie';

export const BackgroundGradient = () => {
    // const colorScheme = useColorScheme(); // Use this when supporting dark mode
    const colorScheme = 'light' as ColorSchemeName;
    const { getColor } = useThemeColors();

    const GRADIENT_TOP_DARK = getColor('$orchidPink100');
    const GRADIENT_BOTTOM_DARK = getColor('$dropletBlue100');

    const gradientColors =
        colorScheme === ('dark' as ColorSchemeName)
            ? ([GRADIENT_TOP_DARK, GRADIENT_BOTTOM_DARK] as const)
            : ([GRADIENT_COLOR_TOP, GRADIENT_COLOR_BOTTOM] as const);

    return (
        <LinearGradient
            colors={gradientColors}
            style={{
                height: '100%',
                width: '100%',
                position: 'absolute',
                top: 0,
            }}
        />
    );
};
